import {RemoteGetHealthRequestSchedulePermission} from 'data/usecases/private/booking-flow/health/remote-get-health-request-schedule-permission';
import {GetHealthRequestSchedulePermission} from 'domain/usecases/private/booking-flow/health/get-health-request-schedule-permission';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthRequestSchedulePermission = (): GetHealthRequestSchedulePermission =>
	new RemoteGetHealthRequestSchedulePermission(
		makeBFFApiUrl(BookingFlowEndPoints.healthRequestSchedulePermission),
		makeAuthorizeHttpClientDecorator(),
	);
